/**
 * axios配置
 */
import Vue from "vue";
import VueAxios from "vue-axios";
import axios from "axios";
import wx from "weixin-js-sdk";
import $store from "@/store";
import dialog from "@utils/dialog";

Vue.use(VueAxios, axios);

// 设置统一的url
axios.defaults.baseURL = process.env.VUE_APP_API_URL, // api 的 base_url
    /* 请求拦截器 */
    axios.interceptors.request.use(
        (config) => {
            const token = $store.state.app.token;
            console.log('请求token----------:', token);
            config.headers['Content-Type'] = 'application/json';
            config.headers["Authorization"] = token;
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

/* 响应拦截器 */
axios.interceptors.response.use(
    (response) => {
        // debugger
        const {code, msg} = response.data;
        if (code === "00000" || code === "Success") {
            return response.data;
        } else {
            // debugger
            // 响应数据为二进制流处理(Excel导出)
            // if (response.data instanceof ArrayBuffer) {
            //   return response;
            // }
            // dialog.error(msg || "系统出错");
            // this.$message.error(msg ||'系统出错');
            return Promise.reject(new Error(msg || "系统出错"));
        }
    },
    (error) => {
        const {msg, code} = error.response.data;
        if (code === "A0230") {
            wx.miniProgram.navigateTo({
                url: `/pages/index/index`
            });
        } else {
            dialog.error(msg || "系统出错");
            return Promise.reject(new Error(msg || "系统出错"));
        }
    }
);
